const homepage_tour = {
	steps: {
		company: {
			description: "Here you can view and edit your company's data.",
			title: "Company",
		},
		firstview: {
			description:
				"You can choose to start a short tour (about 1 minute) so you know what the portal can do and where to find data and products.",
			title: "Welcome to the Tuxis Portal",
		},

		homepage: {
			description:
				"Here you have an overview of the services purchased. If you want to return to this homepage, click on the Tuxis logo at the top of the left sidebar.",
			title: "Homepage",
		},

		personal: {
			business: {
				description:
					"Settings and details for your personal account can be found here including your password vault, SSH keys, email addresses for notifications and two-factor authentication (2FA).\nFunctional items such as changing the password and setting communication language can also be found here.",
			},
			private: {
				description:
					"Settings and details for your personal account can be found here including your password vault, SSH keys, email addresses for notifications and two-factor authentication (2FA).\nFunctional items such as changing the password and setting communication language can also be found here.",
			},
			title: "Personal",
		},

		products_and_services: {
			description:
				"This is where you manage products and services. Here you can create or order, edit and terminate new products and services.",
			title: "Products and services",
		},

		relations: {
			description:
				"Relations allow you to link products and services to a person, company or department. This allows you to keep track of which products you have created for whom.",
			title: "Relations",
		},

		shortcuts: {
			description:
				"Here you can find shortcuts to switch between light and dark themes, log out, manage shared passwords and report problems.",
			title: "Shortcuts",
		},

		username: {
			description: "Here you can log out and check who you are logged in as.",
			title: "Username",
		},
	},
};

export default homepage_tour;
